import { Auth as AmplifyAuth } from '@aws-amplify/auth';

const mockToken = {
    getJwtToken: () => 'mock-jwt-token',
};

const mockSession = {
    getAccessToken: () => mockToken,
    isValid: () => true,
};

// The auth module return if real authentication is not needed (i.e., for testing)
const mockAuth = {
    currentSession: () => mockSession,
    configure: () => {
        /* do nothing */
    },
    signIn: () => {
        /* do nothing */
    },
    signOut: () => {
        /* do nothing */
    },
    federatedSignIn: () => {
        /* do nothing */
    },
};

// Whether or not the authentication should use the AWS authentication, or a mock implementation
const shouldMockAuth =
    (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') &&
    process.env.REACT_APP_MOCK_API === 'true';

const Auth = shouldMockAuth ? mockAuth : AmplifyAuth;

export { Auth };
